import { Suspense, useEffect } from 'react';
import Aos from 'aos';
import { Outlet } from 'react-router-dom';

import '@mantine/carousel/styles.css';

import { Center, Loader } from '@mantine/core';

import '@mantine/core/styles.css';
import '@mantine/charts/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/dropzone/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/tiptap/styles.css';
import 'dayjs/locale/pt-br';
import 'flag-icons/css/flag-icons.css';
import './app.css';

import { EmailVerificationReminder } from './components/Auth/EmailVerificationReminder';
import { AuthInit } from './contexts/AuthContext';
import { useAdPixels } from './hooks/useAdPixels';

export default function App() {
  // Pixel da Meta e Google Analytics: só depois do "Aceitar" dos cookies
  useAdPixels();

  useEffect(() => {
    Aos.init({
      duration: 1200,
      once: true,
    });

    import('./lib/leafletInit');
  }, []);

  return (
    <AuthInit>
      <Suspense
        fallback={
          <Center h="100vh">
            <Loader color="principal" type="bars" />
          </Center>
        }
      >
        <Outlet />
      </Suspense>
      {/* Quem entrou sem confirmar o e-mail: modal ao entrar e lembrete bege em todas as telas */}
      <EmailVerificationReminder />
    </AuthInit>
  );
}
